import { ShopFieldsFragment } from "client/graphql/commerce-api"

import { useShopContext } from "../ShopContext"
import { OuterWrapper } from "../ui/styles/Containers"

import AddedToCart from "./AddedToCartConfirmation"
import MultiProductSelection from "./MultiProductSelection"
import { ProductDetails } from "./ProductDetails"

export type ProductFlowProps = {
  shop: ShopFieldsFragment
  showCart?: () => void
}

const ProductFlow = ({ showCart = () => {} }: ProductFlowProps) => {
  const {
    currentlySelectedProductId,
    addedProduct,
    setAddedProduct,
    resetView,
  } = useShopContext()

  const handleShowCart = () => {
    setAddedProduct(null)
    showCart()
  }

  return (
    <OuterWrapper>
      {addedProduct && (
        <AddedToCart
          item={addedProduct}
          continueShopping={resetView}
          handleShowCart={handleShowCart}
          dismissModal={() => setAddedProduct(null)}
        />
      )}
      {currentlySelectedProductId ? (
        <ProductDetails />
      ) : (
        <MultiProductSelection />
      )}
    </OuterWrapper>
  )
}

export default ProductFlow
